import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import LoginPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/LoginPage";
import "./styles.css";

export default function CaptureFastBalancesPasswordEntered(props) {
    // initalize a new BCMSStateManagerCRUD instance using the default page data
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "userID" ], "geo****")
    .update([ "password" ], "0123456789")
    .update([ "userIDValOnChange" ], "geo****")
    .update([ "passwordValOnChange" ], "0123456789")
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "showFastBalancesSetupView" ], true)
    .submit();

    return <div className="password-entered-003"><LoginPage data={ data } ui={ ui } /></div>
}
